import React, { useEffect } from 'react';
import { Form, Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import Layout from '../../components/layout/Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import { useStore } from '../../stores/root-store-context';
import { useTranslation } from 'react-i18next';

const ResetPasswordForm: React.FC = () => {
  const [form] = Form.useForm();
  const { employeesStore } = useStore();
  const navigate = useNavigate();

  const { t } = useTranslation();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const token = query.get('token') || '';
  const email = query.get('email') || '';

  useEffect(() => {
    if (!token || !email) {
      message.error(t("Invalid token or email"));
      navigate('/404');
    }
  }, [token, email]);

  const onFinish = async (values: { password: string; confirm: string }) => {
    if (values.password !== values.confirm) {
      message.error(t("Passwords do not match"));
      return;
    }

    try {
      employeesStore.restorePassword(email, token, values.password);
      message.success(t("Password changed!"));
      navigate("/login");
    } catch (error) {
      message.error(t("Failed to change password."));
    }
  };

  return (
    <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={t("Forgot Password")}>
      <div style={{ marginTop: 50 }}></div>
      <Form form={form} name="reset_password" onFinish={onFinish}
        style={{ margin: 'auto', width: '500px' }}
        layout="vertical">
        <Form.Item
          name="password"
          label={t("New password")}

          rules={[
            { required: true, message: t("enterNewPassword") },
            {
              pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{6,}$/,
              message: t("Password must be at least 6 characters and include uppercase, lowercase, number, and special character")
            }
          ]}
          hasFeedback
        >
          <Input.Password prefix={<LockOutlined />} placeholder={t("New password")} styles={{ input: { padding: 16 } }} />
        </Form.Item>

        <Form.Item
          name="confirm"
          label={t("ConfirmPassword")}
          dependencies={['password']}
          hasFeedback
          rules={[
            { required: true, message: t("ConfirmPassword") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) return Promise.resolve();
                return Promise.reject(new Error(t("Passwords do not match")));
              },
            }),
          ]}
        >
          <Input.Password prefix={<LockOutlined />} placeholder={t("ConfirmPassword")} styles={{ input: { padding: 16 } }} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit"
            className='theme-btn'
            style={{ height: 65 }} block>
            {t("ChangePassword")}
          </Button>
        </Form.Item>
      </Form>
    </Layout>
  );
};

export default ResetPasswordForm;
